import { observeModal } from '../video-embed/video-embed';

class Modal {
  constructor() {
    this.modalWrappers;
    this.modalWrappers = document.querySelectorAll('[data-modal-id]');

    this.modalWrappers.forEach((modal) => {
      const id = modal.getAttribute('data-modal-id');
      const modalBtn = document.querySelector(`[data-modal-btn-id="${id}"]`);
      const modalInner = modal.querySelector('[data-modal-inner]');

      if (!modal || !modalInner) {
        return false;
      }

      const modalClose = document.createElement('button');
      modalClose.className = 'modal__close-btn';
      const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      svg.classList.add('icon');
      svg.setAttribute('width', 20);
      svg.setAttribute('height', 20);
      const svgUse = document.createElement('use');
      svgUse.setAttribute('href', '/assets/images/svg/spritemap.svg#icon-close');
      svg.appendChild(svgUse);
      modalClose.appendChild(svg);

      modalInner.insertBefore(modalClose, modalInner.firstChild);

      modalBtn &&
        modalBtn.addEventListener(
          'click',
          this.showModal.bind(null, modal, modalClose)
        );
      modalClose &&
        modalClose.addEventListener('click', this.hideModal.bind(null, modal));
      modal.addEventListener('click', this.hideModal.bind(null, modal));
      modalInner.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
      });

      observeModal(modal);
    });
  }

  showModal(modal, modalClose, event) {
    event.preventDefault();
    event.stopPropagation();
    modal.classList.add('is-open');
  }

  hideModal(modal, event) {
    event.preventDefault();
    event.stopPropagation();
    modal.classList.remove('is-open');
  }
}

export default Modal;
